<app-base-action-modal
  modalTitle="Update Email"
  primaryLabel="Update Email Address"
  i18n-modalTitle
  i18n-primaryLabel
  [hideSecondary]="true"
  (closeClicked)="closeModal()"
  (primaryClicked)="form.submitForm()">
  <app-loading *ngIf="isLoading$ | async" [options]="(loadingOpts$ | async) ?? undefined" />
  <lib-reactive-form-group
    #form
    [bindTo]="changeEmailReq$ | async"
    [applyDisabledStylesToAllElements]="true"
    [includeIconWithError]="true"
    [customErrorMessageMap]="customErrorMap"
    (formSubmitted$)="formSubmitted($event)">
    <lib-reactive-form-email
      [required]="true"
      [disabled]="true"
      label="Current Email Address"
      i18n-label
      [bindingProperty]="'currentEmail'"
      [inputName]="'currentEmail'" />
    <lib-reactive-form-email
      [required]="true"
      label="New Email"
      i18n-label
      [bindingProperty]="'newEmail'"
      [inputName]="'email'" />
    <lib-reactive-form-email
      [required]="true"
      label="Confirm New Email"
      i18n-label
      [confirmEmail]="true"
      [inputName]="'confirmEmail'" />
  </lib-reactive-form-group>
</app-base-action-modal>
